import { render, staticRenderFns } from "./LinkBucket.vue?vue&type=template&id=a1a2d98e"
import script from "./LinkBucket.vue?vue&type=script&lang=js"
export * from "./LinkBucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports